import { render, staticRenderFns } from "./Users_Follower.vue?vue&type=template&id=246cdfaa&"
import script from "./Users_Follower.vue?vue&type=script&lang=js&"
export * from "./Users_Follower.vue?vue&type=script&lang=js&"
import style0 from "./Users_Follower.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports